import { useEffect, useState } from 'react';
import { listVoices } from '../api';
import { useClientId } from '../hooks/useClient';
import type { Voice } from '../types/db';

export default function Voices() {
  const clientId = useClientId();
  const [voices, setVoices] = useState<Voice[]>([]);
  const [defaultVoiceId, setDefaultVoiceId] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listVoices(clientId)
      .then((v) => {
        setVoices(v);
        if (v[0]) setDefaultVoiceId(v[0].id);
      })
      .finally(() => setLoading(false));
  }, [clientId]);

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <h1 className="text-xl font-bold text-slate-900">Voci</h1>
      <p className="text-sm text-slate-500">
        Seleziona la voce predefinita per il tuo radiogiornale.
      </p>

      {loading ? (
        <p className="text-sm text-slate-500">Caricamento…</p>
      ) : voices.length === 0 ? (
        <p className="text-sm text-slate-500">
          Nessuna voce configurata.
        </p>
      ) : (
        <div className="space-y-3">
          {voices.map((v) => (
            <label
              key={v.id}
              className={`flex cursor-pointer items-center gap-4 rounded-xl border bg-white p-4 transition ${
                defaultVoiceId === v.id
                  ? 'border-brand-500 ring-1 ring-brand-500'
                  : 'border-slate-200 hover:border-slate-300'
              }`}
            >
              <input
                type="radio"
                name="defaultVoice"
                value={v.id}
                checked={defaultVoiceId === v.id}
                onChange={() => setDefaultVoiceId(v.id)}
                className="h-4 w-4 text-brand-600 focus:ring-brand-500"
              />
              <div className="flex-1">
                <p className="font-semibold text-slate-900">{v.name}</p>
                <p className="text-xs text-slate-500">
                  ElevenLabs ID: {v.eleven_voice_id}
                </p>
                {v.default_settings && (
                  <p className="mt-1 text-xs text-slate-400">
                    {JSON.stringify(v.default_settings)}
                  </p>
                )}
              </div>
              {defaultVoiceId === v.id && (
                <span className="rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700">
                  Predefinita
                </span>
              )}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
